<script>
    import { Link } from 'svelte-routing';
    import TopMenu from '../components/TopMenu.svelte';
    import {store} from '../stores.js';

    const axis = store('axis', '', false);
</script>

{#if !$axis}
    <TopMenu title="Загрузка" />
{/if}

<div id="appCapsule" class="{$axis ? 'pt-1' : ''}">
    <div class="section full mt-2">
        <div class="wide-block pt-2 pb-2">
            <div class="alert alert-outline-primary fade show text-center" role="alert">
                <h4 class="alert-title">Загружаем данные</h4>
    
                Если зависло или что-то пошло не так можно вернуться <Link to="/dashboard">назад</Link>.
            </div>
        </div>
    </div>
</div>
